export const BACKEND_NAME_INPUT_ID = 'previewBarBackendName';
export const TYPING_REASON = 'input-change';
export const BACKEND_HEALTH_TIMEOUT_MS = 3000;
export const VISIBILITY_CHANGE_EVENT = 'visibilitychange';
export const VISIBLE_STATE = 'visible';
export const PREVIEW_BAR_LOCALE = 'en';
export const PREVIEW_BAR_POSITION_KEY = 'rio_preview_bar_position';
export const DRAG_THRESHOLD_PX = 4;
